import { FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { socialLinks } from '../data';

const icons = {
  linkedin: FaLinkedinIn,
  instagram: FaInstagram,
};

export default function SocialLinks({ className = '' }) {
  return (
    <ul className={`social-links${className ? ` ${className}` : ''}`} aria-label="Rime on social media">
      {socialLinks.map((link) => {
        const Icon = icons[link.id];
        return (
          <li key={link.id}>
            <a href={link.href} target="_blank" rel="me noopener noreferrer" aria-label={link.label}>
              <Icon aria-hidden="true" />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
